document.addEventListener('DOMContentLoaded', function () {
	initMobileNav();
	initDropdowns();
	initMegaHeights();
	initResizeEffect();

	// Close nav only if clicking outside the menu
	document.addEventListener('click', function (e) {
		const target = e.target;
		if (document.body.classList.contains('nav-active')) {
			if (!target.closest('.nav-opener') && !target.closest('.nav-drop')) {
				document.body.classList.remove('nav-active');
				removeDropdownActiveClasses(); // Remove active classes on dropdowns
			}
		}
	});
});

// MobileNav initialization
function initMobileNav() {
	const navOpeners = document.querySelectorAll('.nav-opener');
	const navClosers = document.querySelectorAll('.nav-close');

	navOpeners.forEach(function (opener) {
		opener.addEventListener('click', function (e) {
			e.preventDefault();
			document.body.classList.add('nav-active');
		});
	});

	navClosers.forEach(function (closer) {
		closer.addEventListener('click', function (e) {
			e.preventDefault();
			document.body.classList.remove('nav-active');
			removeDropdownActiveClasses(); // Remove active classes on dropdowns
		});
	});
}

// Function to initialize dropdown behavior
function initDropdowns() {
	const dropdownMenus = document.querySelectorAll('.dropdown-menu');

	dropdownMenus.forEach(function (menu) {
		const dropdownItems = menu.querySelectorAll('li:has(> .dropdown-menu)');

		// Add active class to the first item by default
		if (dropdownItems.length > 0) {
			const firstItem = dropdownItems[0];
			firstItem.classList.add('active');
			const firstDropdown = firstItem.querySelector('.dropdown-menu');
			if (firstDropdown) {
				firstDropdown.classList.add('active');
			}
		}

		// Add hover behavior to switch active class
		dropdownItems.forEach(function (item) {
			item.addEventListener('mouseenter', function () {
				// Remove active from all dropdownItems and their children
				dropdownItems.forEach(i => {
					i.classList.remove('active');
					const nested = i.querySelector('.dropdown-menu');
					if (nested) nested.classList.remove('active');
				});

				// Add active to hovered item and its nested dropdown
				item.classList.add('active');
				const childDropdown = item.querySelector('.dropdown-menu');
				if (childDropdown) {
					childDropdown.classList.add('active');
				}
			});
		});
	});
}

// main menu js 15/04/25
window.addEventListener('load', function() {
	if (window.innerWidth < 768) return;

	const parentMenus = document.querySelectorAll('.navigation > li > .dropdown-menu');

	parentMenus.forEach(parent => {
		const childDropdowns = parent.querySelectorAll('.dropdown-menu.mega');
		let tallestHeight = 0;

		childDropdowns.forEach(child => {
			// Save original styles
			const originalDisplay = child.style.display;
			const originalVisibility = child.style.visibility;
			const originalPosition = child.style.position;

			// Temporarily show in place (no offset) for accurate layout height
			child.style.display = 'block';
			child.style.visibility = 'hidden';
			child.style.position = 'absolute';

			const height = child.scrollHeight; // More reliable for layout height
			if (height > tallestHeight) {
				tallestHeight = height;
			}

			// Revert styles
			child.style.display = originalDisplay;
			child.style.visibility = originalVisibility;
			child.style.position = originalPosition;
          
		});

		if (tallestHeight > 0) {
			parent.style.minHeight = `${tallestHeight}px`;
		}
	});
});

// Resize effect with debounce
function debounce(func, wait) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, args), wait);
	};
}

function initResizeEffect() {
	const optimizedResize = debounce(() => {
		if (window.innerWidth > 767) {
			document.body.classList.remove('nav-active');
			removeDropdownActiveClasses();
		}
	}, 200);

	window.addEventListener('resize', optimizedResize);
}

// Remove all active classes
function removeDropdownActiveClasses() {
	document.querySelectorAll('.dropdown-menu .active').forEach(el => {
		el.classList.remove('active');
	});
}

// Set dropdown heights based on mega menus
function initMegaHeights() {
	const dropdownMenus = document.querySelectorAll(".dropdown-menu");
	dropdownMenus.forEach((menu) => {
		const megaMenu = menu.querySelector(".mega");
		if (megaMenu) {
			menu.style.minHeight = megaMenu.offsetHeight + "px";
		}
	});
}